import * as React from 'react';
import { LocationState } from './location-state';
import { TenantOnlyState } from './tenant-only-state';
import { TerritoryState } from './territory-state';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface MainSelectorBreadcrumbViewProps {
  interactive?: boolean;
  locationColor?: string;
  locationName?: string;
  tenantName: string;
  territoryName?: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function MainSelectorBreadcrumbView({
  interactive,
  locationColor,
  locationName,
  tenantName,
  territoryName,
}: MainSelectorBreadcrumbViewProps): React.JSX.Element {
  // Show location breadcrumb when we have a location name.
  const hasLocation = !!locationName;
  const hasTerritory = !!territoryName;

  if (hasLocation) {
    return (
      <LocationState
        interactive={interactive}
        locationColor={locationColor}
        locationName={locationName}
        tenantName={tenantName}
        territoryName={territoryName}
      />
    );
  }

  if (hasTerritory) {
    return <TerritoryState interactive={interactive} tenantName={tenantName} territoryName={territoryName} />;
  }

  return <TenantOnlyState interactive={interactive} tenantName={tenantName} />;
}
